// 跨域登陆，同时登陆无界AI专业版
export function crossLogin(token: string, backUrl?: string) {
  window.location.href = `${
    process.env.NEXT_PUBLIC_WUJIEAI_PRO_HOST
  }/api/cross-login?token=${token}&redirect=${encodeURIComponent(
    !!backUrl ? window.location.origin + backUrl : window.location.href
  )}`
}

export enum AreaCodeEnum {
  CN = '+86',
  HK = '+852',
  MACAO = '+853',
  TAIWAN = '+886',
}
